import { Injectable, LOCALE_ID, inject } from '@angular/core';

const ICORTEX_SITE_LOCALE_PREFIXES: Record<string, string> = {
  es: '/es',
  pt: '/pt',
  ko: '/ko'
};

/**
 * @description Resolves locale-aware app paths (e.g. /es/signup) preserving current site language prefix.
 */
@Injectable( {
  providedIn: 'root'
} )
export class IcortexLocalizedPathService {

  private readonly localeId = inject( LOCALE_ID );


  /**
   * @description Returns a localized absolute path keeping /es, /pt or /ko when applicable.
   * @param path Absolute or relative app path.
   * @return Locale-aware absolute path.
   */
  getLocalizedPath( path: string ): string {

    const normalizedPath = path.startsWith( '/' ) ? path : `/${ path }`;
    const prefix = this.resolveLocalePrefix();

    if ( !prefix ) {

      return normalizedPath;
    }

    if ( normalizedPath === '/' ) {

      return `${ prefix }/`;
    }

    return `${ prefix }${ normalizedPath }`;
  }


  /**
   * @description Resolves locale prefix from URL path first, then from Angular LOCALE_ID.
   * @return Locale prefix (/es, /pt, /ko) or empty for default English.
   */
  private resolveLocalePrefix(): string {

    if ( typeof window !== 'undefined' && window.location ) {

      const firstSegment = ( window.location.pathname || '' )
        .split( '/' )
        .filter( ( segment ) => segment.length > 0 )[ 0 ]
        ?.toLowerCase();

      if ( firstSegment && ICORTEX_SITE_LOCALE_PREFIXES[ firstSegment ] ) {

        return ICORTEX_SITE_LOCALE_PREFIXES[ firstSegment ];
      }
    }

    const localeFromAngular = ICORTEX_SITE_LOCALE_PREFIXES[ this.localeId ];

    if ( localeFromAngular ) {

      return localeFromAngular;
    }

    return '';
  }
}
